import Vue from 'vue'
import Vuetify from 'vuetify'
import i18n from '@/plugins/vue-i18n'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

Vue.use(Vuetify, {
  theme: Object.assign({
    primary: '#1976D2',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }, window.theme || {
    primary: '#4c82c0',
    secondary: '#ddecff',
    overSecondary: '#4c82c0',
    titleColor: '#fb8d96'
  }),
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  options: {
    customProperties: true
  }
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js